import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && anonKey);

/** Cliente browser; só usar quando `supabaseConfigured` é true. */
export const supabase = supabaseConfigured
    ? createClient(url, anonKey, {
          auth: {
              flowType: "pkce",
              detectSessionInUrl: true,
              persistSession: true,
              autoRefreshToken: true,
          },
      })
    : null;
